import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_DOCTOR_HOME_VISIT_REQUESTS } from "../../action-types/actions";

import i18n from "../../i18n";
export const getDoctorHomeVisitRequests = createAsyncThunk(
  ACTIONS_DOCTOR_HOME_VISIT_REQUESTS.fetch_requests,
  async ({ status, page = 1, limit = 10 }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const queryParams = new URLSearchParams({
        ...(status && { status }),
        page: String(page),
        limit: String(limit),
      }).toString();

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getDoctorHomeVisitRequests}?${queryParams}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message || i18n.t("toast.failedToFetchHomeVisitRequests"),
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorFetchingHomeVisitRequests");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
